// Legal content for Tam Ayar Landing Page

export const legalContent = {
  privacyPolicy: {
    title: "Gizlilik Politikası",
    content: `YS SOFTWARE YAZILIM TEKNOLOJİ TİCARET VE SANAYİ LİMİTED ŞİRKETİ ("Şirket"), kuyumculuk sektörüne özel dijital çözümler sunmak amacıyla geliştirilmiş olan Tam Ayar ("Uygulama") mobil platformunun sahibidir. Kullanıcı bilgilerinin güvenliği ve gizliliği bizim için son derece önemlidir. Bu politika, uygulamamızın kullanımında toplanan verilerin nasıl işlendiğini ve korunduğunu açıklar.

1. Toplanan Bilgiler
Tam Ayar, kullanıcı deneyimini geliştirmek amacıyla sınırlı sayıda bilgi toplar. Bu bilgiler:
• Ad, soyad, e-posta ve telefon numarası gibi temel iletişim bilgileri,
• Uygulama içi kullanım verileri ve tercihler,
• Kuyumculuk işlemlerine dair kur, ürün ve bildirim tercihleri,
• Panel girişleri sırasında kullanılan cihaz, IP adresi ve bağlantı bilgileri şeklindedir.

Bu veriler, kullanıcı onayı ile alınır ve yalnızca hizmet kalitesini artırmak amacıyla kullanılır.

2. Verilerin Kullanımı
Toplanan bilgiler aşağıdaki amaçlarla kullanılabilir:
• Uygulama performansını ve kullanıcı deneyimini iyileştirmek,
• Kuyumculara özel anlık kur, fiyat güncellemeleri ve hesaplama hizmetleri sağlamak,
• Bildirimler, kampanyalar veya sistem duyurularını iletmek,
• Destek ve iletişim süreçlerini yönetmek.

3. Veri Güvenliği
Tam Ayar, kullanıcı verilerini güvenli sunucularda saklar ve yasal zorunluluklar haricinde üçüncü taraflarla paylaşmaz. Tüm iletişim SSL (Secure Socket Layer) sertifikasıyla korunur ve yönetim panellerine sadece yetkili kişiler, belirlenen güvenlik protokolleri çerçevesinde erişebilir.

4. Üçüncü Taraf Servisleri
Uygulama, performans analizi, anlık bildirim yönetimi veya altyapı hizmetleri için Google Firebase, Apple Services veya benzeri güvenilir üçüncü taraf servislerden yararlanabilir. Bu servislerin kendi gizlilik politikaları geçerlidir.

5. Kullanıcı Hakları
Kullanıcılar istedikleri zaman kişisel verilerinin silinmesini, düzeltilmesini veya güncellenmesini talep edebilirler. Bu talepler info@tamayar.com adresine iletilebilir. Şirket, talebinizi en kısa sürede değerlendirip sonuçlandıracaktır.

6. Güncellemeler
Bu gizlilik politikası, yasal gereklilikler veya hizmet güncellemeleri doğrultusunda zaman zaman güncellenebilir. Güncellenmiş sürümler, www.tamayar.com adresinde yayınlanır ve uygulama üzerinden kullanıcılara duyurulur.

Tam Ayar – YS SOFTWARE YAZILIM TEKNOLOJİ TİCARET VE SANAYİ LİMİTED ŞİRKETİ
Vergi No: 9830865766
Web: www.tamayar.com
E-posta: info@tamayar.com`
  },

  termsOfUse: {
    title: "Kullanım Koşulları",
    content: `1. GİRİŞ
İşbu Kullanım Koşulları ("Koşullar"), YS SOFTWARE YAZILIM TEKNOLOJİ TİCARET VE SANAYİ LİMİTED ŞİRKETİ ("Şirket") tarafından işletilen www.tamayar.com internet sitesi ve Tam Ayar mobil uygulamasına ("Platform" veya "Uygulama") erişim ve kullanım şartlarını belirlemektedir.

Platformu indirerek, üye olarak veya ziyaret ederek; işbu Koşulları okuduğunuzu, içeriğini anladığınızı ve bu koşullarla bağlı olduğunuzu kabul etmiş sayılırsınız. Eğer bu şartları kabul etmiyorsanız, lütfen Uygulama'yı kullanmayınız.

2. HİZMETİN KAPSAMI
Tam Ayar, kuyumculuk sektörü için geliştirilmiş; anlık kur takibi, fiyat hesaplama, ürün yönetimi ve sektörel bildirimler sağlayan dijital bir platformdur. Şirket, Uygulama'nın içeriğini, kapsamını ve sunduğu hizmetleri dilediği zaman değiştirme, askıya alma veya sonlandırma hakkını saklı tutar.

3. KULLANIM ŞARTLARI VE ÜYELİK
3.1. Kullanıcı, Uygulama'yı kullanırken verdiği bilgilerin (ad, iletişim vb.) doğru ve güncel olduğunu taahhüt eder.
3.2. Üyelik hesabı ve şifre güvenliği tamamen Kullanıcının sorumluluğundadır. Kullanıcı, hesabından yapılan işlemlerden bizzat sorumludur.
3.3. Uygulama, yalnızca yasal amaçlar için kullanılabilir. Uygulama'nın güvenliğini tehdit edecek, işleyişini bozacak veya diğer kullanıcıların zarar görmesine neden olacak faaliyetlerde bulunulması yasaktır.

4. VERİ DOĞRULUĞU VE SORUMLULUK REDDİ (ÖNEMLİ)
4.1. Tam Ayar üzerinden sunulan altın, döviz, gümüş ve diğer emtia fiyatları, piyasa verilerine dayanarak bilgilendirme amacıyla sunulmaktadır.
4.2. Şirket, veri akışında yaşanabilecek gecikmelerden, teknik aksaklıklardan veya üçüncü taraf veri sağlayıcılarından kaynaklanan hatalardan sorumlu tutulamaz.
4.3. Uygulama üzerindeki veriler bir yatırım tavsiyesi niteliği taşımaz. Kullanıcı, bu verilere dayanarak yaptığı ticari işlemlerden, alım-satım kararlarından ve olası maddi zararlardan bizzat kendisi sorumludur. Şirket, ticari kayıplardan dolayı sorumlu tutulamaz.

5. FİKRİ MÜLKİYET HAKLARI
Tam Ayar markası, logosu, Uygulama'nın tasarımı, yazılımı, veritabanı ve içeriklerin tüm fikri mülkiyet hakları YS SOFTWARE YAZILIM TEKNOLOJİ TİCARET VE SANAYİ LİMİTED ŞİRKETİ'ne aittir. İzinsiz kopyalanması, çoğaltılması, tersine mühendislik yapılması veya ticari amaçla (lisans kapsamı dışında) kullanılması yasaktır.

6. GİZLİLİK
Kullanıcının Platformu kullanımı sırasında paylaştığı kişisel veriler, Tam Ayar Gizlilik Politikası kapsamında işlenir ve korunur. Kullanıcı, Uygulama'yı kullanarak Gizlilik Politikası hükümlerini de kabul etmiş sayılır.

7. SORUMLULUĞUN SINIRLANDIRILMASI
Şirket, Uygulama'nın kesintisiz, hatasız veya virüssüz olacağını garanti etmez. Uygulama'nın kullanımı sırasında oluşabilecek teknik arızalar, veri kayıpları veya cihaz hasarlarından Şirket sorumlu değildir. Hizmet, "olduğu gibi" sunulmaktadır.

8. DEĞİŞİKLİKLER
Şirket, işbu Kullanım Koşulları'nı herhangi bir ön bildirimde bulunmaksızın güncelleme hakkına sahiptir. Güncellenen koşullar www.tamayar.com adresinde veya Uygulama içerisinde yayınlandığı tarihte yürürlüğe girer.

9. UYGULANACAK HUKUK VE YETKİ
İşbu Koşullar'dan doğabilecek her türlü uyuşmazlığın çözümünde Türk Hukuku uygulanacak olup, İstanbul Mahkemeleri ve İcra Daireleri yetkilidir.

10. İLETİŞİM
Kullanım koşulları ile ilgili sorularınız için bizimle iletişime geçebilirsiniz:

Unvan: YS SOFTWARE YAZILIM TEKNOLOJİ TİCARET VE SANAYİ LİMİTED ŞİRKETİ
Vergi No: 9830865766
Web: www.tamayar.com
E-posta: info@tamayar.com`
  },

  kvkk: {
    title: "KVKK Aydınlatma Metni",
    content: `KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ HAKKINDA AYDINLATMA METNİ

1. Veri Sorumlusu
6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; veri sorumlusu sıfatıyla YS SOFTWARE YAZILIM TEKNOLOJİ TİCARET VE SANAYİ LİMİTED ŞİRKETİ ("Şirket" veya "Tam Ayar") tarafından aşağıda açıklanan kapsamda işlenebilecektir.

Veri Sorumlusu Künyesi:
• Unvan: YS SOFTWARE YAZILIM TEKNOLOJİ TİCARET VE SANAYİ LİMİTED ŞİRKETİ
• Vergi No: 9830865766
• Web Adresi: www.tamayar.com
• E-Posta: info@tamayar.com

2. Kişisel Verilerin İşlenme Amacı
Toplanan kişisel verileriniz, Şirketimiz tarafından sunulan Tam Ayar mobil uygulaması ve internet sitesi ("Platform") hizmetlerinden faydalanabilmeniz, kuyumculuk sektörüyle ilgili anlık veri akışının sağlanması ve hesaplama araçlarının kullanımı amaçlarıyla işlenmektedir.

Kişisel verileriniz şu amaçlarla işlenir:
• Hizmet Sunumu: Kullanıcı kaydının oluşturulması, uygulama içi özelliklerin (canlı kur takibi, kar/zarar hesaplama, favori listeleri vb.) kişiselleştirilmesi ve çalıştırılması.
• İletişim Faaliyetleri: Sistem güncellemeleri, önemli piyasa bildirimleri, bakım/onarım çalışmaları ve üyeliğinizle ilgili gerekli bilgilendirmelerin yapılması.
• İşlem Güvenliği: 5651 sayılı Kanun gereği trafik kayıtlarının (log tutulması), IP adreslerinin ve cihaz bilgilerinin saklanması; yetkisiz erişimlerin ve hileli işlemlerin engellenmesi.
• Müşteri Memnuniyeti: Talep ve şikayetlerinizin yönetilmesi, uygulama deneyiminin iyileştirilmesi, hata/bug raporlarının analizi.
• Hukuki Yükümlülükler: Yetkili kamu kurum ve kuruluşlarına (Mahkemeler, Savcılıklar, BTK vb.) talep halinde bilgi verilmesi.

3. İşlenen Kişisel Veri Kategorileri
Platform'u kullanımınız sırasında aşağıdaki veri kategorileri işlenebilmektedir:
• Kimlik Bilgileri: Ad, Soyad.
• İletişim Bilgileri: E-posta adresi, Telefon numarası.
• İşlem Güvenliği Bilgileri: IP adresi, Cihaz bilgisi (Marka/Model/ID), Uygulama giriş-çıkış kayıtları, Log kayıtları.
• Müşteri İşlem Bilgileri: Uygulama içi tercihler, izlenen ürünler, bildirim ayarları, talep ve şikayet bilgileri.

4. Kişisel Verilerin Aktarılması
Kişisel verileriniz; KVKK'nın 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde;
• Hizmet Sağlayıcılar: Uygulamanın barındırılması (hosting/sunucu hizmetleri), anlık bildirim (push notification) servisleri ve teknik altyapı hizmeti alınan yurt içi veya (açık rızanızın veya yasal şartların varlığı halinde) yurt dışı merkezli güvenilir üçüncü taraflara,
• Hukuki Zorunluluklar: Kanunen yetkili kamu kurumlarına ve özel kişilere (örneğin; savcılık talepleri, mahkeme kararları),

Yalnızca hizmetin ifası ve hukuki yükümlülüklerin yerine getirilmesi amacıyla sınırlı olarak aktarılabilecektir. Verileriniz, izniniz olmaksızın pazarlama amacıyla üçüncü kişilere satılmamaktadır.

5. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi
Kişisel verileriniz, Tam Ayar mobil uygulaması, tamayar.com web sitesi, e-posta veya çağrı merkezi kanalları aracılığıyla elektronik ortamda otomatik yollarla toplanmaktadır.

Bu veriler, KVKK'nın 5. maddesinde belirtilen şu hukuki sebeplere dayanarak işlenmektedir:
• Bir sözleşmenin kurulması veya ifası: Üyelik sözleşmesinin kurulması ve uygulama hizmetlerinin size sunulması için veri işlemenin gerekli olması.
• Hukuki Yükümlülük: Şirket'in yasal yükümlülüklerini (log tutma, yasal bildirimler vb.) yerine getirebilmesi.
• Meşru Menfaat: İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, Şirket'in meşru menfaatleri için veri işlenmesinin zorunlu olması (Örn: Uygulama güvenliğinin sağlanması, hataların giderilmesi).
• Açık Rıza: İşleme faaliyetinin yukarıdaki şartlardan birine girmemesi durumunda (örneğin; kişiselleştirilmiş pazarlama kampanyaları) açık rızanıza başvurulur.

6. İlgili Kişinin Hakları (KVKK Madde 11)
Kişisel veri sahibi olarak, Kanun'un 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:
• Kişisel verilerinizin işlenip işlenmediğini öğrenme,
• Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
• Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
• Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,
• Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,
• KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme,
• İşlemlerin (düzeltme/silme) kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
• İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
• Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme.

7. Başvuru ve İletişim
Yukarıda belirtilen haklarınızı kullanmak için taleplerinizi, yazılı olarak veya kayıtlı elektronik posta (KEP) adresi, güvenli elektronik imza, mobil imza ya da Şirketimize daha önce bildirdiğiniz ve sistemimizde kayıtlı bulunan elektronik posta adresinizi kullanmak suretiyle aşağıdaki adrese iletebilirsiniz.

İletişim E-Posta: info@tamayar.com

Şirketimiz, talebin niteliğine göre talebi en kısa sürede ve en geç 14 (on dört) gün içinde ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin ayrıca bir maliyeti gerektirmesi hâlinde, Kişisel Verileri Koruma Kurulu'nca belirlenen tarifedeki ücret alınabilir.`
  }
};
